// convert imported to data format we use in db
export const importedDataToRawData = (importedData) => {
    return {
        id: importedData.Azonosító,
        lastname: importedData.Vezetéknév,
        firstname: importedData.Keresztnév,
        email: importedData['E-mail cím'],
        registration: importedData.Regisztráció,
        birthdate: importedData['Születési dátum'],
        lang: importedData.Nyelv,
        role: importedData.Jogosultság,
        vipurl: importedData['Dolgozói QR'],
        delete: importedData.Törlés,
        lurdylifemember: importedData['Lurdy Life tag']?.toLowerCase() === 'igen',
    };
};

// convert data we use in db to easily readable data
export const rawDataToReadableData = (rawData) => {
    let isMember = 'Nem';

    // if lurdylifemember is an object, then it's read from the table's row so we need to check it's key
    if (typeof rawData.lurdylifemember !== 'object') {
        isMember = rawData.lurdylifemember ? 'Igen' : 'Nem';
    } else isMember = rawData.lurdylifemember.key === 'member' ? 'Igen' : 'Nem';

    return {
        Azonosító: rawData.id,
        Vezetéknév: rawData.lastname,
        Keresztnév: rawData.firstname,
        'E-mail cím': rawData.email,
        Regisztráció: rawData.registration,
        'Születési dátum': rawData.birthdate,
        Nyelv: rawData.lang,
        Jogosultság: rawData.role,
        'Dolgozói QR': rawData.vipurl,
        'Lurdy Life tag': isMember,
    };
};
